import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

export const CoverDetailsStyles = styled.div`
  width: 100%;
  padding: 24px;
  border-radius: 8px;
  background: ${theme.primaryColours.white.main};
  color: ${theme.primaryColours.aubergine.main};
  @media (min-width: ${theme.grid.resolution.tablet.width}px) {
    width: ${theme.grid.resolution.tablet.container}px;
    margin: 0 auto;
  }

  @media (min-width: ${theme.grid.resolution.desktop.width}px) {
    width: ${theme.grid.resolution.desktop.container}px;
  }

  .content-wrapper {
    border-bottom: 1px solid ${theme.tints.darkAubergine};
    @media (min-width: ${theme.grid.resolution.tablet.width}px) {
      display: flex;
      justify-content: space-between;
      gap: 24px;
    }
  }

  .heading {
    margin-bottom: ${theme.grid.spacing.xs}px;

    @media (min-width: ${theme.grid.resolution.tablet.width}px) {
      margin-bottom: ${theme.grid.spacing.base}px;
    }
  }

  .section {
    margin-bottom: ${theme.grid.spacing.base}px;
    @media (min-width: ${theme.grid.resolution.tablet.width}px) {
      width: 130px;
      margin-bottom: 83px;
    }

    @media (min-width: ${theme.grid.resolution.desktop.width}px) {
      width: 164px;
      margin-bottom: 12px;
    }

    &.other-drivers {
      .driver {
        margin-bottom: ${theme.grid.spacing.xs}px;
        @media (min-width: ${theme.grid.resolution.desktop.width}px) {
          .first-name,
          .last-name {
            display: block;
          }
          margin-bottom: ${theme.grid.spacing.s}px;
        }
      }
    }
  }

  .edit-details {
    margin-left: auto;
    position: relative;
    display: block;
    top: ${theme.grid.spacing.base}px;
    margin-bottom: ${theme.grid.spacing.base}px;
  }
`
